import React, {useEffect, useState} from "react";
import GoogleMapReact from "google-map-react";
import Geocode from "react-geocode";
import {isProdMode} from "../../constants/mode";
import Marker from "./Marker";
import PropTypes from "prop-types";

// Fetch API key from env
let api_key = null;
if (isProdMode) {
  // Only enable the Google API in production to reduce cost
  api_key = "AIzaSyAB-HDch7b6EtCqbHEG_m8vAhCV4mvPhOo";
  Geocode.setApiKey(api_key);
}

const AnyReactComponent = ({text}) => (
  <div
    style={{
      width: "100px",
      maxWidth: "100px",
      fontSize: "10px",
      color: "#073e57",
    }}
  >
    {text}
  </div>
);

/** This component is wrapper around GoogleMapReact component of google-map-react library.
 * This component will take height and width from its parent element so its important to set height and width for parent element.
 *
 * https://www.npmjs.com/package/google-map-react
 */

const GoogleMap = (props) => {
  const {address, zoom = 15} = props;
  const [latitude, setLat] = useState(0);
  const [longitude, setLng] = useState(0);
  const [fmtAddr, setFmtAddr] = useState();

  useEffect(() => {
    if (api_key != null) {
      Geocode.fromAddress(address).then(
        (response) => {
          const {lat, lng} = response.results[0].geometry.location;
          const {formatted_address} = response.results[0];
          setLat(lat);
          setLng(lng);
          setFmtAddr(formatted_address);
        },
        (error) => {
          throw error;
        }
      );
    }
  }, [address]);

  return (
    // Important! Always set the container height explicitly
    <div style={{height: "100%", width: "100%"}}>
      {latitude && longitude && api_key !== null ? (
        <GoogleMapReact
          bootstrapURLKeys={{key: api_key}}
          center={[latitude, longitude]}
          defaultZoom={zoom}
          yesIWantToUseGoogleMapApiInternals
        >
          <Marker lat={latitude} lng={longitude} name="Here" color="red" />
          <AnyReactComponent lat={latitude} lng={longitude} text={fmtAddr} />
        </GoogleMapReact>
      ) : (
        <div className="d-flex justify-content-center  mt-5">Map is unavailable</div>
      )}
    </div>
  );
};

GoogleMap.propTypes = {
  /** From this address geocode will be found which will be used by reactGoogleMap library */
  address: PropTypes.string.isRequired,
  /** This prop will determine zoom level of map */
  zoom: PropTypes.number,
};

export default React.memo(GoogleMap);
